import { GenericAbortSignal } from "axios";
import { AutoCompleteDataModel, AutoCompleteSuggestions, MprcAutoComplete } from "components/MprcAutoComplete";
import { IAutoCompleteProps } from "components/MprcAutoComplete/AutoComplete";
import { isCanceledError, useCoreApi } from "providers/CoreApiProvider";

////////////////////////////////////////////////////////////////////////////

interface Props extends Omit<IAutoCompleteProps, 'onGetSuggestions'> {
    trainingId: string;
    classroomId: string;
}

////////////////////////////////////////////////////////////////////////////

/**
 * Auto complete de instrutores da turma.
 * @param props
 */
export const ClassroomInstructorsAutoComplete: React.FC<Props> = ({ trainingId, classroomId, onError, ...props }) => {

    const api = useCoreApi();

    ///
    const getSuggestions = (searchText: string, pageNumber: number, pageSize: number, trySelectedHistory: boolean, signal: GenericAbortSignal | undefined): Promise<AutoCompleteSuggestions<AutoCompleteDataModel>> => {
        searchText = searchText.toLowerCase();

        return new Promise<AutoCompleteSuggestions<AutoCompleteDataModel>>((resolve) => {
            api.v1.lmsSuggestions.classroomInstructors({
                searchText,
                pageNumber,
                pageSize,
                trainingId,
                classroomId
            }, { signal })
                .then(result => resolve({
                    items: result.data.items,
                    totalRows: result.data.totalRows
                }))
                .catch(e => {
                    if (!isCanceledError(e)) {
                        resolve({ items: [], totalRows: 0 });
                        if (onError) onError(e);
                    }
                });
        });
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <MprcAutoComplete
            {...props}
            onError={onError}
            onGetSuggestions={getSuggestions}
        />
    );
};